<template>
  <div class="mt20 page_navigation">
    <div :class="start == 1 ? 'navi_item disabled' : 'navi_item'">
      <!-- <chevron-left-icon size="18" :color="start == 1 ? '#999' : '#000'" /> -->
      <span>Prev</span>
    </div>
    <div class="navi_item">
      <span>Next</span>
      <!-- <chevron-right-icon size="18" /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['start', 'total', 'current', 'size'],
  data() {
    return {
      show: 1,
    };
  },
};
</script>

<style lang="less">
.page_navigation {
  display: flex;
  justify-content: start;
  .navi_item {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border: 1px solid #eaeaea;
    border-right: none;
    width: auto;
    background: #fff;
    span {
      display: block;
    }
    cursor: pointer;
  }
  .navi_item.disabled {
    span {
      color: #999;
    }
    cursor: not-allowed;
  }
  .navi_item:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .navi_item:last-child {
    border-right: 1px solid #eaeaea;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
